'use strict';

// Selectors
const selector = {
  input: {
    categoryId: 'input.category-id'
  },
  httpUrl: 'httpUrl',
  urlLink: 'urlLink'
};

// Elements
const element = {
  httpUrl: document.getElementById(selector.httpUrl) || null
};

// Functions

/**
 * Get http url
 * @returns {String} - Url
 */
function getHttpUrl() {
  return element.httpUrl ? element.httpUrl.value : '';
}

/**
 * Get current ajax url with parameters
 * @param {String} params - Parameters to add to url
 * @returns {String} - Url with parameters
 */
function getAjaxUrlWithParams(params) {
  const httpUrl = getHttpUrl();
  const path = httpUrl.split('?')[0] + 'Ajax?';
  const decode = params.includes('hk_promotions') ? false : true;
  const url = decode ? path + decodeURIComponent(params) : path + params;

  return url;
}

/**
 * Update url link in history state
 * @returns {void}
 */
function updateUrlLink() {
  const categoryId = getCategoryId();
  const urlLinkElement = document.getElementById(selector.urlLink) || null;

  if (urlLinkElement && categoryId && categoryId.length > 0) {
    const urlPath = urlLinkElement ? urlLinkElement.getAttribute('href') : '';
    const stateData = {
      path: urlPath,
      title: document.title
    };

    window.history.replaceState(stateData, stateData.title, stateData.path);
  }
}

/**
 * Get current category ID
 * @returns {String} - Category ID
 */
function getCategoryId() {
  const categoryIdElement =
    document.querySelector(selector.input.categoryId) || null;

  return categoryIdElement ? categoryIdElement.value : '';
}

export { getAjaxUrlWithParams, updateUrlLink };
